import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  textarea: {
    '& textarea': { height: 'unset !important' },
  },
  checkChangesContainer: {
    marginTop: '27px',
    columnGap: '19px',
  },
  checkChanges: {
    padding: 0,
  },
  emailRecipientsReportsLabel: {
    color: theme.evPalette.charcoal[900],
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  editContactInfo: {
    color: '#007CAD !important',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  emailInput: {
    width: '100%',
  },
  emailInputRoot: {
    height: 'unset',
    '&.error fieldset': { border: `1px solid ${theme.evPalette.rose[900]} !important` },
  },
  emailInputTag: {
    '&.error': { backgroundColor: theme.evPalette.rose[100] },
  },
  tagDeleteIcon: {
    width: '16px',
    color: theme.evPalette.charcoal[600],
    '&.error': { color: theme.evPalette.rose[900] },
  },
  invalidEmail: {
    color: theme.evPalette.rose[900],
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
  },
}));
